import { redirectData } from '@support/json';
import { isMobile, redirectURL } from '@support/utils';

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return; // 服务端渲染阶段不生效
  if (!isMobile()) return; // 在pc端不生效

  const { redirectPageMapPcToM, baseURLMap } = redirectData();

  const targetURL = redirectURL({
    redirectPageMap: redirectPageMapPcToM,
    baseURLMap,
    locationHref: location.href
  });

  location.replace(targetURL);
});
